import { useCallback } from 'react';
import { useLocalStorage } from '../utils/Hooks/useLocalStorage';
import { getLoginContext } from './Auth';
import { useAuth } from './AuthContext';
import { fetch } from './fetchRefresh';


type FetchOptions = { method: string } & { [p: string]: string }

const useFetchSimple = () => {
    const [user, setCurrentUser] = useLocalStorage<any>("user");
    const [, dispatchSetuser] = useAuth();

    const newFetch: (url: string, options?: FetchOptions) => Promise<{ body: { success: boolean, messages: string[], file?: Buffer } }> =
        useCallback((url, options) => fetch(url, options).then((data) => {
            const theUser = user;
            if (theUser) {
                const { newToken, ...user } = theUser;
                if (newToken) {
                    if (user) setCurrentUser(user);
                    const updatedUser = getLoginContext(user);
                    dispatchSetuser({
                        type: "setAuthDetails", payload: updatedUser
                    });
                }
            }
            return Promise.resolve(data as { body: { success: boolean, messages: string[] } });
        }, (error) => {
            if (error.status === 401) {
                dispatchSetuser({
                    type: "removeAuthDetails"
                });
            }
            return Promise.reject(error);
        }).catch((e) => {
            throw e;
        }), [dispatchSetuser, setCurrentUser, user])
    return newFetch;
}

export default useFetchSimple;